<template>
	<div>
		<img src="/assets/images/desktop/saludo-jefe-de-carrera.png"
		     class="w-100 d-none d-xl-block d-lg-block d-md-none d-sm-none"
		     draggable="false"
		     alt="">
		<img src="/assets/images/movil/saludo-jefe-de-carrera.png"
		     class="w-100 d-block d-xl-none d-lg-none d-md-block d-sm-block"
		     draggable="false"
		     alt="">
		<div class="border-5 border-bottom border-dark-pink"></div>
		<div class="container py-5">
			<div class="row">
				<div class="col-6">
					<div class="h1 text-cyan">
						Busca tu Jefe/a de carrera
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 mb-5">
					<p>En este viaje necesitarás el apoyo de profesionales que te inspiren y que estén comprometidos con
						tu formación desde la admisión hasta el egreso, estas personas son tus jefes/as de carrera y
						quieren ofrecerte un afectuoso saludo de bienvenida. Haz click en el video que corresponda y
						revisa el mensaje que dejaron para ti.</p>
				</div>
			</div>
			<div class="row">
				<div v-for="video in videos"
				     class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-5">
					<div class="ratio ratio-16x9">
						<iframe :src="'https://www.youtube.com/embed/'+video.id+'?rel=0'"
						        :title="video.title" allowfullscreen></iframe>
					</div>
					<div class="text-center py-4">
						<div class="h5 text-blue">
							{{ video.nombre }}
						</div>
						<div class="text-blue">
							{{ video.descripcion }} <b>{{ video.carrera }}</b>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BandaVerSaludos from "../layout/BandaVerSaludos";

export default {
	name: 'jefes-carrera',
	components: {
		BandaVerSaludos
	},
	data: () => ({
		videos: [
			{nombre: 'Maritza Fernández', id: 'RU11BwFQM_k', descripcion: 'Jefa de Carrera de', carrera: 'Obstetricia'},
			{nombre: 'Oriette Soto', id: 'BTgaOnJ1mq4', descripcion: 'Académica de', carrera: 'Enfermería'},
			{nombre: 'Romina Aranda', id: '8qGpiJ8lpiw', descripcion: 'Jefa de Carrera de', carrera: 'Psicología'},
			{nombre: 'Johana Madrigal', id: 'MhJ_dhOI0LA', descripcion: 'Jefa de Carrera de', carrera: 'Trabajo Social'},
			{nombre: 'Marcelo Sanhueza', id: 'Sk03FcGn8b4', descripcion: 'Jefe de Carrera de', carrera: 'Ingeniería Forestal'},
			{nombre: 'Luz Cardona', id: 'Bd2b1KrKXt0', descripcion: 'Jefa de Carrera de', carrera: 'Ingeniería Civil Informática'},
			{nombre: 'Cristian Alarcón', id: 'RU-0urUpouo', descripcion: 'Jefe de Carrera de', carrera: 'Ingeniería Civil Industrial'},
			{nombre: 'Rodrigo Ojeda', id: 'IVOnMehmXIg', descripcion: 'Jefe de Carrera de', carrera: 'Agronomía'},
		]
	}),
}

</script>